module.exports = __webpack_public_path__ + "img/mvl_mobile.efc2b413.png";